const MAX_FILE_SIZE = 8 * 1024 * 1024
const EXCEL_EXTS = ['.xls', '.xlsx']
const CSV_EXTS = ['.csv']

function fileExt(name) {
  const lower = String(name || '').toLowerCase()
  const idx = lower.lastIndexOf('.')
  return idx >= 0 ? lower.slice(idx) : ''
}

export function validateUploadFile(file, { allowCsv = false, maxSize = MAX_FILE_SIZE } = {}) {
  if (!file) {
    return { ok: false, message: '未选择文件' }
  }
  const ext = fileExt(file.name)
  const allowed = allowCsv ? [...EXCEL_EXTS, ...CSV_EXTS] : EXCEL_EXTS
  if (!allowed.includes(ext)) {
    return {
      ok: false,
      message: allowCsv
        ? '文件格式不正确，请上传 .xls、.xlsx 或 .csv 文件'
        : '文件格式不正确，请上传 .xls 或 .xlsx 格式的 Excel 文件'
    }
  }
  if (file.size <= 0) {
    return { ok: false, message: '文件为空，请选择有效的数据文件' }
  }
  if (file.size > maxSize) {
    return { ok: false, message: `文件大小不能超过 ${Math.round(maxSize / 1024 / 1024)}MB` }
  }
  return { ok: true }
}

export function formatImportErrors(result, maxLines = 12) {
  if (!result) return ''
  const errs = Array.isArray(result.errors)
    ? result.errors
    : Array.isArray(result)
      ? result
      : []
  if (!errs.length) return ''
  return errs.slice(0, maxLines).map((item) => {
    if (typeof item === 'string') return item
    if (item && item.line != null) return `第 ${item.line} 行：${item.message || ''}`
    if (item && item.row != null) return `第 ${item.row} 行：${item.message || ''}`
    return String(item && item.message ? item.message : item)
  }).join('\n')
}

export function validateCsvText(text, { minDataRows = 1, expectedMinCols = 1 } = {}) {
  const lines = String(text || '').split(/\r?\n/).filter((line) => line.trim())
  if (lines.length <= minDataRows) {
    return { ok: false, message: '文件没有数据行，请检查是否为空或仅有表头' }
  }
  const headerCols = lines[0].split(',').length
  if (headerCols < expectedMinCols) {
    return { ok: false, message: `表头列数不足（至少需要 ${expectedMinCols} 列）` }
  }
  const badRows = []
  lines.slice(1).forEach((line, idx) => {
    const cols = line.split(',')
    if (cols.length < expectedMinCols) {
      badRows.push(idx + 2)
    }
  })
  if (badRows.length) {
    return {
      ok: false,
      message: `以下行数据列数不足：第 ${badRows.slice(0, 8).join('、')} 行`
    }
  }
  return { ok: true, lines }
}

export function guardUploadFile(vm, file, options = {}) {
  const result = validateUploadFile(file, options)
  if (!result.ok) {
    if (vm && vm.$message) vm.$message.error(result.message)
    return false
  }
  return true
}

export function showImportResult(vm, resp, { successMessage } = {}) {
  if (!vm) return
  const data = resp && resp.data ? resp.data : resp
  const errorsText = formatImportErrors(data)
  if (resp && resp.code === 400 && errorsText) {
    vm.$alert(errorsText, '导入校验失败', { type: 'error' })
    return
  }
  if (errorsText) {
    vm.$alert(`${resp.message || successMessage || '导入完成'}\n\n${errorsText}`, '导入结果', { type: 'warning' })
    return
  }
  vm.$message.success(resp.message || successMessage || '导入成功')
}
